import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-black/50 border-t border-white/10 py-12 relative z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <Link 
                to="/"
                className="cursor-pointer hover:opacity-80 transition-opacity duration-300"
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_globalized-site/artifacts/nb42ugut_PROTOS%20AI%20AGency.png" 
                  alt="Protos AI Agency Logo"
                  className="w-28 h-18 object-contain"
                />
              </Link>
            </div>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-6">{t('home.footer.servicesTitle')}</h4>
            <ul className="space-y-3">
              <li><Link to="/services/dimosia-dioikisi" className="text-gray-400 hover:text-white transition-colors">{t('services.dimosiaDioikisi')}</Link></li>
              <li><Link to="/services/asfaleia" className="text-gray-400 hover:text-white transition-colors">{t('services.asfaleia')}</Link></li>
              <li><Link to="/services/politistiki-klironomia" className="text-gray-400 hover:text-white transition-colors">{t('services.politistikiKlironomia')}</Link></li>
              <li><Link to="/services/ygeia-ekpaidefsi" className="text-gray-400 hover:text-white transition-colors">{t('services.ygeiaEkpaidefsi')}</Link></li>
              <li><Link to="/services/erevna-anaptyxi" className="text-gray-400 hover:text-white transition-colors">{t('services.erevnaAnaptyxi')}</Link></li>
              <li><Link to="/services/green-horizon" className="text-gray-400 hover:text-white transition-colors">{t('services.greenHorizon')}</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-6">{t('home.footer.contactTitle')}</h4>
            <ul className="space-y-3">
              <li className="text-gray-400">Αρχαιολογικού Μουσείου 17</li>
              <li className="text-gray-400">54640 Thessaloniki</li>
              <li className="text-gray-400">+30 2104407770</li>
              <li className="text-green-300 font-medium">24h Tel. +30 2311320091</li>
              <li className="text-gray-400">info@ai-agency.gr</li>
              <li className="text-gray-400">www.ai-agency.gr</li>
              <li><Link to="/privacy" className="text-cyan-300 hover:text-cyan-200 transition-colors">{t('nav.privacyPolicy')}</Link></li>
              <li>
                <button 
                  onClick={() => {
                    localStorage.removeItem('cookieConsent');
                    localStorage.removeItem('cookiePreferences');
                    window.location.reload();
                  }}
                  className="text-cyan-300 hover:text-cyan-200 transition-colors cursor-pointer text-left"
                >
                  {t('home.footer.cookieSettings')}
                </button>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/10 mt-12 pt-8">
          {/* Social Media Links */}
          <div className="flex justify-center space-x-6 mb-6">
            <a 
              href="https://www.instagram.com/aiagencygr/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-pink-400 transition-colors transform hover:scale-110 duration-300"
              aria-label="Instagram"
            >
              <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
            
            <a 
              href="https://x.com/PROTOSAIAGENCY" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-blue-400 transition-colors transform hover:scale-110 duration-300"
              aria-label="Twitter/X"
            >
              <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            
            <a 
              href="https://www.linkedin.com/company/protos-ai-agency/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-blue-500 transition-colors transform hover:scale-110 duration-300"
              aria-label="LinkedIn"
            >
              <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
          </div>
          
          <div className="text-center">
            <p className="text-gray-400">
              {t('home.footer.copyright')}
            </p>
            <p className="text-gray-500 text-xs mt-2">
              ΑΦΜ 802208607 ΓΕΜΗ 172146906000
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
